import { useEffect } from 'react';
import { usePathname } from '@/i18n/navigation';
import { useSetAtom } from 'jotai';
import { addPathAtom } from '@/store/path-history';

/**
 * 路径历史记录 Hook
 * 
 * 功能：
 * - 监听路径变化
 * - 自动记录路径历史到 store（双重记录）
 * 
 * 记录方式：
 * 1. paths: 去重记录，只有路径真正变化时才记录（最多6条）
 * 2. allPaths: 完整记录，即使路径重复也记录（最多6条）
 * 
 * 使用场景：
 * - 判断用户从哪个页面跳转而来
 * - 实现智能返回功能
 * - 分析用户行为路径
 * 
 * 注意：每次路径变化时，会同时更新 paths（去重）和 allPaths（完整）两种记录
 */
export function usePathHistory() {
  const pathname = usePathname();
  const addPath = useSetAtom(addPathAtom);

  useEffect(() => {
    // 记录路径（自动处理去重和完整两种记录）
    if (pathname) {
      addPath(pathname);
    }
  }, [pathname, addPath]);
}

